import { render, staticRenderFns } from "./AppointTabContent.vue?vue&type=template&id=e322d37c&scoped=true&"
import script from "./AppointTabContent.vue?vue&type=script&lang=js&"
export * from "./AppointTabContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e322d37c",
  null
  
)

export default component.exports